// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hI9YShvaJDbEdXkACdoW{background-color:rgba(0,0,0,0)}.hI9YShvaJDbEdXkACdoW:hover{background-color:#deebff}`, "",{"version":3,"sources":["webpack://./../@depmap/selects/src/styles/OptimizedSelectOption.scss"],"names":[],"mappings":"AAAA,sBACE,8BAAA,CACA,4BACE,wBAAA","sourcesContent":[".optimizedSelectOptionHover {\n  background-color: transparent;\n  &:hover {\n    background-color: rgb(222, 235, 255);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"optimizedSelectOptionHover": `hI9YShvaJDbEdXkACdoW`
};
export default ___CSS_LOADER_EXPORT___;
